import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { instance2 } from "../utils/axiosInstance"; // Ensure the Axios instance path is correct
import CalendarIcon from "../img/calendaricon.svg"; // Replace with the correct path for your calendar icon
import { formatNumber } from "../numberingformat"; // Ensure formatNumber works for formatting
import DapurIcon from "../img/logodapursidebar.png";
import { basecode } from "../settings/roboto";
import { jsPDF } from "jspdf"; // Import jsPDF for PDF generation
import { useLocation } from "react-router-dom";
import { CheckCircleIcon, EyeIcon } from '@heroicons/react/16/solid';
  import { useNavigate } from "react-router-dom";
  import { ReactComponent as VerticalLine } from "../img/verticalline.svg";
  import { ReactComponent as MagnificationLogo } from "../img/magnificationlensicon.svg";


export default function PenerimaanBahanDapur() {
  
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [locationId, setLocationId] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [editableRows, setEditableRows] = useState({});

      const [searchQuery, setSearchQuery] = useState(""); // State for search input
  const kitchenId = localStorage.getItem("kitchenId")
    // Access state from the navigate call
    const location = useLocation();
  
    // Extract startDate and endDate from the URL query string
    const queryParams = new URLSearchParams(location.search);
    const startDate = queryParams.get('startDate');
    const endDate = queryParams.get('endDate');
  
  
const localDateString = (thedate) =>{

  const year = thedate.getFullYear();
  const month = String(thedate.getMonth() + 1).padStart(2, '0');  // Adding 1 because months are 0-based
  const day = String(thedate.getDate()).padStart(2, '0');
  
console.log("startDate", thedate);
const localDateString = `${year}-${month}-${day}`;

return localDateString

}

  const getWeekStartAndEndDates = (date) => {
    const current = new Date(date);
    const dayOfWeek = current.getDay();
    const monday = new Date(startDate? startDate : current);
    monday.setDate(current.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    return { startDate: localDateString(monday), endDate: localDateString(sunday)};
  };

 // const { startDate, endDate } = getWeekStartAndEndDates(selectedDate);

  useEffect(() => {
    const storedLocationId = localStorage.getItem("locationId");
    if (storedLocationId && !isNaN(storedLocationId)) {
      const parsedId = parseInt(storedLocationId, 10);
      setLocationId(parsedId);
    }
  }, []);

  useEffect(() => {
    const fetchDataForDate = async (date) => {
      if (!locationId) {
        console.log("Location ID not yet available.");
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const response = await instance2.get(`delivery_order_header/kitchen/${kitchenId}`);
        //${localDateString(selectedDate)}/${localDateString(selectedDate)}
        const retrievedData = response.data?.data || response.data || [];
        const sortedData = retrievedData.sort((a, b) => a.kitchen_id - b.kitchen_id);

        setData(sortedData);

        // Set editable rows state
        const initialEditableState = retrievedData.reduce((acc, item, index) => {
          acc[index] = {
            id: item.id,
            location_id: item.location_id,
            kitchen_id: item.kitchen_id,
            delivery_date: item.delivery_date,
            ingredient_id: item.ingredient_id, // Initially, set it to ingredient_value
            qty: item.qty, // Remaining qty after ingredient value is setent_value
          };
          return acc;
        }, {});
        setEditableRows(initialEditableState);
        console.log("initial",initialEditableState)
      } catch (err) {
        setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    if (locationId) {
      fetchDataForDate(selectedDate);
    }
  }, [selectedDate, locationId]);

  const handleOrderQtyChange = (index, value) => {
    setEditableRows((prev) => {
      const updatedRows = { ...prev };
      updatedRows[index] = { ...updatedRows[index], edited_qty: value };
      return updatedRows;
    });
  };

  const calculateEditableQtyAndRemainingQty = (index, data) => {
    let editableQty, remainingQty, cumulativeSum;

    for (let i = 0; i <= index; i++) {    
      if (i > 0 && data[i].ingredient_name !== data[i - 1].ingredient_name) {
      cumulativeSum = (data[index].qty_received, editableRows[i].edited_qty);} else 
      cumulativeSum = parseInt(cumulativeSum? cumulativeSum : 0) + parseInt(editableRows[i]?.edited_qty );
    }
  
    // For the first row or when ingredient_name changes:
    // if (index === 0 || data[index - 1].ingredient_name !== data[index].ingredient_name) {
    //   editableQty = Math.min(data[index].qty_received, data[index].ingredient_value); // First row: Min of qty_received and ingredient_value
    //   remainingQty = (data[index].qty_received - cumulativeSum); // Remaining quantity after first row's edited_qty
    // } else {
      // For subsequent rows:
      // editable_qty is determined based on the previous remaining_qty and ingredient_value
      editableQty = Math.min(editableRows[index - 1]?.remaining_qty, data[index].ingredient_value); // Max between previous remaining qty and ingredient_value
      
      // Calculate cumulative sum for the current row
      
      // Calculate remaining qty after deducting cumulative sum
      remainingQty = (data[index]?.qty_received - cumulativeSum); // Calculate remaining qty
    // }
  
    return { editableQty, remainingQty, cumulativeSum };
  };
  
  const handleSubmit = async () => {
    const editedData = Object.values(editableRows).map((row) => ({
      id: row.id,
      qty: row.edited_qty, // Submit raw numeric value
      location_id: locationId, // Submit raw numeric value
      ingredient_id: row.ingredient_id, // Submit raw numeric value
      kitchen_id: row.kitchen_id, // Submit raw numeric value
      uoq_id: row.uoq_id, // Submit raw numeric value
      delivery_date: row.delivery_date, // Submit raw numeric value
      admin_id: localStorage.getItem("userAuthentication"), // Submit raw numeric value
      order_id: row.order_id, // Submit raw numeric value
    }));

    try {
      const response = await instance2.post("/delivery_order", {
        locationId,
        editedData,
      });

      if (response.status === "OK") {
        alert("Data submitted successfully");
      } else {
        alert("Submission failed");
      }
    } catch (error) {
      console.error("Error during submission", error);
      alert("An error occurred while submitting the data");
    }
  };

  const CustomInput = React.forwardRef(({ value, onClick, isOpen }, ref) => (
    <button
      className="flex items-center justify-between w-full px-4 py-2 border rounded-[15px] bg-white"
      onClick={onClick}
      ref={ref}
      type="button"
    >
      <div className="flex items-center gap-2">
        <img src={CalendarIcon} alt="Calendar" className="h-5 w-5 text-gray-500" />
        <div className="w-px h-5 bg-gray-300 mx-1 me-3"></div>
        <span>
          {new Date(value).toLocaleDateString("id-ID", {
            year: "numeric",
            month: "long",
            day: "2-digit",
          })}
        </span>
      </div>
      <div
        className={`text-black font-semibold transform transition-transform duration-500 ease-in-out ${
          isOpen ? "rotate-180" : "rotate-0"
        }`}
      >
        ▼
      </div>
    </button>
  ));

  const handleDownloadPDF = async (orderNumber, orderDetails, supplierName, orderDate) => {
    const doc = new jsPDF();
  
    // Embed the Roboto font (add the correct base64 font data here)
    const robotoFont = basecode; // Replace with base64-encoded Roboto font data
    doc.addFileToVFS('Roboto-Regular.ttf', robotoFont);
    doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
    doc.setFont('Roboto', 'normal'); // Set default font to Roboto
  
    // Convert local icon to Base64
    const loadImageAsBase64 = (imgSrc) =>
      new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.src = imgSrc;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = (err) => reject(err);
      });
  
    // Load icon
    const iconBase64 = await loadImageAsBase64(DapurIcon);
  
    // Title and Supplier Information Block
    const pageWidth = doc.internal.pageSize.width;
    const text = 'PURCHASE ORDER';
    const textWidth = doc.getTextWidth(text);
    const xPosition = (pageWidth - textWidth) / 2;
  
    const addHeader = (doc, pageWidth, supplierName, orderNumber, orderDate) => {
      doc.setFontSize(12);
      doc.text(text, xPosition, 10);
  
      const supplierInfo = {
        Pemasok: supplierName,
        Nomor: orderNumber,
        'Tanggal ': new Date(orderDate).toLocaleDateString('id-ID', {
          year: 'numeric',
          month: 'long',
          day: '2-digit',
        }),
      };
  
      const marginLeft = 10;
      const textYOffset = 20;
      const labelWidth = Math.max(
        ...Object.keys(supplierInfo).map((key) => doc.getTextWidth(`${key}   `))
      );
  
      let yOffset = textYOffset;
      Object.entries(supplierInfo).forEach(([key, value]) => {
        doc.text(`${key}`, marginLeft, yOffset);
        const colonX = marginLeft + labelWidth;
        doc.text(':', colonX, yOffset);
        const valueX = colonX + 2;
        doc.text(value, valueX, yOffset);
  
        yOffset += 5;
      });
  
      const iconWidth = 23;
      const iconHeight = 18;
      const iconX = pageWidth - iconWidth - 10;
      const iconY = textYOffset - 6;
      doc.addImage(iconBase64, 'PNG', iconX, iconY, iconWidth, iconHeight);
    };
  
    let yOffset = 40;
    const totalPageHeight = doc.internal.pageSize.height;
    let pageNumber = 1;
  
    const addFooter = (currentPage, totalPages) => {
      const footerText = `Page ${currentPage} of ${totalPages}`;
      doc.setFontSize(10);
      doc.text(footerText, pageWidth - doc.getTextWidth(footerText) - 10, totalPageHeight - 10);
    };
  
    addHeader(doc, pageWidth, supplierName, orderNumber, orderDate);
  
    // Initialize grand total
let grandTotal = 0;

// Loop through order details
Object.entries(orderDetails).forEach(([deliveryDate, items], index) => {
  const sectionHeight = items.length * 5 + 26;

  // Check for page break
  if (yOffset + sectionHeight > totalPageHeight - 20) {
    doc.addPage();
    yOffset = 40;
    pageNumber += 1;
    addHeader(doc, pageWidth, supplierName, orderNumber, orderDate);
  }

  // Calculate section subtotal
  const sectionSubtotal = items.reduce(
    (sum, item) => sum + (parseFloat(item.price_total) || 0),
    0
  );
  grandTotal += sectionSubtotal; // Add to grand total

  // Draw gray border for the section
  doc.setDrawColor(200, 200, 200);
  doc.rect(10, yOffset, pageWidth - 20, sectionHeight, 'S');

  // Add delivery date
  doc.setFontSize(10);
  doc.text(
    `Delivery Date: ${new Date(deliveryDate).toLocaleDateString('id-ID', {
      year: 'numeric',
      month: 'long',
      day: '2-digit',
    })}`,
    15,
    yOffset + 5
  );

  yOffset += 7;

  // Add table for items
  doc.autoTable({
    startY: yOffset,
    head: [['#', 'Bahan', 'Jumlah', 'Unit', 'Harga/Unit', 'Subtotal']],
    body: items.map((item, index) => [
      `${index + 1}.`,
      item.ingredient_name || '-',
      formatNumber(item.order_qty), // Formatted
      item.uoq_code || '-',
      formatNumber(item.price_unit) || '-', // Formatted
      formatNumber(item.price_total) || '-', // Formatted
    ]),
    columnStyles: {
      0: { halign: 'center', cellWidth: '5%' },
      1: { halign: 'left', cellWidth: 120 },
      2: { halign: 'right', cellWidth: '10%' },
      3: { halign: 'center', cellWidth: '5%' },
      4: { halign: 'right', cellWidth: '10%' },
      5: { halign: 'right', cellWidth: '10%' },
    },
    styles: {
      cellPadding: 1,
      fontSize: 8,
      overflow: 'linebreak',
      font: 'Roboto',
    },
    headStyles: {
      fillColor: [220, 220, 220],
      textColor: [0, 0, 0],
    },
  });

  // Update yOffset for next section
  yOffset = doc.lastAutoTable.finalY + 5;

 // Set font size to 8 for subtotal
doc.setFontSize(8);
doc.text(`Subtotal: ${formatNumber(sectionSubtotal)}`, pageWidth - 60, yOffset);
yOffset += 10; // Adjust yOffset for next section
});

// Display grand total
doc.text(`Grand Total: ${formatNumber(grandTotal)}`, pageWidth - 60, yOffset);
    
  
    const pageCount = doc.internal.getNumberOfPages();
  
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      addFooter(i, pageCount);
    }
  
    doc.save(`${orderNumber}.pdf`);
  };
  const filteredData = data.filter((item) => {
    const formattedDate = new Date(item.delivery_date).toLocaleDateString("id-ID", {
      year: "numeric",
      month: "long",
      day: "2-digit",
    });
  
    return (
      String(item.ingredient_count).toLowerCase().includes(searchQuery.toLowerCase()) || // Match ingredient count (converted to string)
      formattedDate.toLowerCase().includes(searchQuery.toLowerCase()) // Match formatted date
      // String(item.id).includes(searchQuery) // Match ID as string
    );
    
  });

  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const itemsPerPage = 10; // Number of items per page
    // Pagination logic
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const paginatedData = filteredData.slice(
      (currentPage - 1) * itemsPerPage,
      currentPage * itemsPerPage
    );
  
    const handlePreviousPage = () => {
      if (currentPage > 1) setCurrentPage(currentPage - 1);
    };
  
    const handleNextPage = () => {
      if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };
  
    // Determine which page numbers to show
    let pageNumbers = [];
    const maxVisiblePages = 5;
  
    if (totalPages <= maxVisiblePages) {
      pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      if (currentPage <= 3) {
        // Near the beginning
        pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
      } else if (currentPage >= totalPages - 2) {
        // Near the end
        pageNumbers = [1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
      } else {
        // In the middle
        pageNumbers = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
      }
    }
  return (
    <div className="p-4">
      <h1 className="block text-black text-xl sm:text-2xl my-2 font-medium">Daftar Delivery Order</h1>
      
             {/* Search Bar */}
                      <div className="flex rounded-[50px] flex-row justify-start items-center gap-2 w-full md:w-auto">
                        <div className="flex rounded-full p-2 bg-white text-gray-400 shadow-sm items-center w-full md:w-auto justify-start">
                          <MagnificationLogo />
                          <VerticalLine className="mx-1" />
                          <input
                            type="text"
                            placeholder="Telusuri data berdasarkan tanggal atau jumlah bahan baku"
                            className="flex-1 bg-transparent outline-none border-none text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-sm"
                            style={{
                              width: `${"Telusuri data berdasarkan tanggal atau jumlah bahan baku".length}ch`,
                            }}
                            value={searchQuery} // Controlled input
                            onChange={(e) => setSearchQuery(e.target.value)} // Update search query
                          />
                        </div>
                      </div>
    <div className="flex flex-col gap-6">
      <div className="flex flex-col items-center gap-4">
        {/* <div className="border-t border-gray-400 w-full flex-1"></div> */}
        {/*<div className="flex flex-row w-full items-center justify-start">
           <div className="font-semibold">Tanggal:</div>
          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            customInput={
              <CustomInput
                value={selectedDate.toLocaleDateString("id-ID", {
                  year: "numeric",
                  month: "long",
                  day: "2-digit",
                })}
                isOpen={isOpen}
              />
            }
            onCalendarOpen={() => setIsOpen(true)}
            onCalendarClose={() => setIsOpen(false)}
            dateFormat="yyyy-MM-dd"
            filterDate={(date) => {
              const day = date.getDay();
              return day !== 0 && day !== 6; // Disable weekends
            }}
          />
        </div>*/}
          {/* <button
          className="w-1/2 px-3 py-4 bg-merah-no text-white rounded-[50px] hover:bg-merah-hover uppercase"
          onClick={handleSubmit}
        >
          Terima Semua
        </button>  */}
        
        {/* <div className="border-t border-gray-400 w-full flex-1"></div> */}
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <div className="overflow-x-auto">
          {data.length > 0 ? (
            <table className="fixed-table border-collapse w-full text-left">
              <thead>
                <tr className="bg-white">
                <th className="border-b border-gray-400 px-4 py-2 uppercase rounded-tl-[15px]">No</th>
                  <th className="border-b border-gray-400 px-4 py-2 uppercase">Tanggal</th>
                  <th className="border-b border-gray-400 px-4 py-2 uppercase text-center">
                    Jumlah Bahan Baku
                  </th><th className="border-b border-gray-400 px-4 py-2 uppercase text-left">
                    Diterima
                  </th>
                  <th className="border-b border-gray-400 px-4 py-2 uppercase text-center rounded-tr-[15px]">
                    Aksi
                  </th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((item, index) => {
                  const { editableQty, remainingQty, cumulativeSum } = calculateEditableQtyAndRemainingQty(index, data);
                  const isLastOccurrence = index === data.length - 1 || data[index].ingredient_name !== data[index + 1]?.ingredient_name;


                  return (
                    <tr key={index} className={index % 2 === 0 ? "bg-transparent" : "bg-gray-200"}>
                    <td className="border-b border-gray-400 px-4 py-2">
                    {index + 1 + (currentPage - 1) * itemsPerPage}
                    </td>
                        <td className="border-b border-gray-400 px-4 py-2">
                          {new Date(item.delivery_date).toLocaleDateString("id-ID", {
      year: "numeric",
      month: "long",
      day: "2-digit",
    })}
                        </td>


                    {/* <td className="border-b border-gray-400 px-4 py-2">{localDateString(new Date (item.delivery_date))}</td>
                      <td className="border-b border-gray-400 px-4 py-2 text-right">
                        {formatNumber(item.ingredient_value??0)}
                      </td> */}
                      {/* <td className="border-b border-gray-400 px-4 py-2">
                          <input
                            type="text"
                            value={formatNumber(editableRows[index]?.edited_qty ?? editableQty)} // Format it here for display
                            className="border rounded px-2 py-1 text-right"
                            onChange={(e) => {
                              const rawValue = e.target.value.replace(/[^\d]/g, ""); // Remove non-numeric characters
                              const numericValue = parseInt(rawValue, 10) || 0; // Parse as integer
                              handleOrderQtyChange(index, numericValue); // Update the raw value in state
                            }}
                          />
                      </td> */}
                        <td className="border-b border-gray-400 px-4 py-2 text-center" >
                          {formatNumber(item.ingredient_count)}
                        </td>
                        <td className="border-b border-gray-400 px-4 py-2 text-center" >                                  
                          {item.received === 1 ? <CheckCircleIcon className="w-5 h-5 text-green-500"/>: ""}
                        </td>

                      {/* <td className="border-b border-gray-400 px-4 py-2 text-center">
                        <button
                className="px-4 py-2 bg-blue-500 text-white rounded"
                // onClick={() =>
                //   handleDownloadPDF(
                //     orderNumber,
                //     orderDetails,
                //     orderDetails[Object.keys(orderDetails)[0]][0].supplier_name,
                //     orderDetails[Object.keys(orderDetails)[0]][0].date.split("T")[0]
                //   )
                // }
              >
                Download PDF
              </button>
              </td> */}
              <td className="border-b border-gray-400 px-4 py-2 text-center">

                                  <button
                                    className="text-gray-500 p-2 rounded hover:text-green-500"
                                    // onClick={() => handleEdit(item)}
                                  >
                                    <EyeIcon className="w-5 h-5" 
                        onClick={() => navigate(item.received !== 1 ? `/penerimaanDO?startDate=${localDateString(new Date(item.delivery_date))}` : `/penerimaanbahansortbydapur?kitchenId=${kitchenId}&startDate=${localDateString(new Date(item.delivery_date))}`)}/>
                                  </button>
                                </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <p>No data available for the selected date.</p>
          )}
        </div>
      )}

<div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
      {/* Previous Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === 1
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handlePreviousPage}
        disabled={currentPage === 1}
      >
        <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
      </button>

      {/* Page Numbers */}
      <div className="flex items-center">
        {pageNumbers.map((page, index) => (
          <span
            key={index}
            onClick={() => typeof page === "number" && setCurrentPage(page)}
            className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
              currentPage === page ? "text-black font-semibold" : "text-gray-700"
            } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
          >
            {page}
          </span>
        ))}
      </div>

      {/* Next Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === totalPages
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
      >
        <span className="font-bold text-lg sm:text-2xl">{">"}</span>
      </button>
    </div>
      
    </div>
    </div>
  );
}
